export default __webpack_public_path__ + "static/media/23_tag_clothes-dryer.216f3df9.svg";